<template>
  <div class="forgot-page container">

      <div class="columns is-centered">
        <div class="column is-half">
          <h1 class="title">Reset Password</h1>
          <form class="login-form" @submit.prevent="reset">
            <b-field label="Email">
                  <b-input type="email" placeholder="email" v-model="email"></b-input>
            </b-field> 
            <div class="field is-grouped">
              <div class="control">
                <button class="button is-link is-primary is-medium">Reset</button>
              </div>
              <div class="control">
                <router-link class="button is-text is-medium" :to="{name: 'LoginPage'}">Login</router-link>
              </div>
            </div>
          </form>
        </div>
      </div>

  </div>
</template>

<script>
export default {
  name: 'ForgotPage',
  data () {
    return {
      email: null
    }
  },

  methods:{
    reset: function(){

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/ForgotPage.vue